import React, { useState, useEffect } from 'react';
import ArrowDownWhite from '../../assets/icons/arrow_down_white.svg';
import { NavLink, useLocation } from 'react-router-dom';
import { links } from './dataLinks';
import { Nav } from './Header.styles';
function Navbar({activeDropdown, handleLinkClick, isBurgerMenuOpen }) {
	const allLinks = [...links];
	const { pathname } = useLocation();
	// const [activeDropdown, setActiveDropdown] = useState(null);
	//
	// const toggleDropdown = (id) => {
	// 	setActiveDropdown(activeDropdown === id ? null : id);
	// };
	//
	// const handleLinkClick = (id, dropdown) => {
	// 	if (dropdown) {
	// 		toggleDropdown(id);
	// 	} else {
	// 		setActiveDropdown(null); // Close dropdown if it's not a dropdown link
	// 	}
	// };
	//
	// useEffect(() => {
	// 	setActiveDropdown(null);
	// }, []);


	return (
		<Nav className={isBurgerMenuOpen ? 'active' : ''}>
			<ul className={isBurgerMenuOpen ? 'open' : ''}>
				{allLinks.map(item => {
					const { id, url, text, dropdown } = item;
					return (
						<li key={id} className="nav-item">
							<NavLink
								to={url || "#"}
								style={{ display: "flex", alignItems: "center" }}
								onClick={() => handleLinkClick(id, dropdown)}
								className={({ isActive }) => {
								if (dropdown) {
									return dropdown.some((sub) => pathname.startsWith(sub.url)) ? 'active-link' : '';
								}
								return isActive && (text !== "Players" || activeDropdown !== null) ? 'active-link' : '';
							}}
							>
								{text}
								{dropdown && <img style={{ width: "24px", height: "24px" }} src={ArrowDownWhite} alt="Arrow Down" />}
							</NavLink>
							{dropdown && activeDropdown === id && (
								<ul className="dropdown-menu">
									{dropdown.map(subItem => (
										<li key={subItem.id} className={"dropdown-li"}>
											<NavLink to={subItem.url} onClick={() => handleLinkClick(subItem.id)}>{subItem.text}</NavLink>
										</li>
									))}
								</ul>
							)}
						</li>
					);
				})}
			</ul>
		</Nav>
	);
}

export default Navbar;



// import React from 'react';
// import ArrowDownWhite from '../../assets/icons/arrow_down_white.svg';
// import { NavLink } from 'react-router-dom';
// import { links } from './dataLinks';
// import { Nav } from './Header.styles';
//
// function Navbar() {
//
//
// 	return (
// 		<Nav>
// 			<ul>
// 				{allLinks.map(item => {
// 					const { id, url, text } = item;
//
// 					return (
// 						<li key={id}>
// 							<NavLink to={url} style={{display:"flex", alignItems:"center"}}>{text}
// 								{text ==="Players" && <img style={{width:"24px", height:"24px"}} src={ArrowDownWhite} alt={""}/>}
// 							</NavLink>
// 						</li>
// 					);
// 				})}
// 			</ul>
// 		</Nav>
// 	);
// }
//
// export default Navbar;
